import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";

var _templateObject,
    _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ImportEstimation/components/WithDotsIcon/WithDotsIcon.styled.ts",
    _templateObject2,
    _templateObject3;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
export var WithDotsIconRoot = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 24px;\n  height: 24px;\n  position: relative;\n"])));
export var DotsWrap = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  position: absolute;\n  right: ", ";\n  bottom: -1px;\n"])), function (p) {
  return p.withIcon ? '8px' : '-1px';
});
export var Dot = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 6px;\n  height: 6px;\n  background-color: ", ";\n  border-radius: 50%;\n\n  &:not(:last-child) {\n    margin-right: 1px;\n  }\n"])), function (p) {
  return p.isGreen ? '#0D9966' : '#4c5ecf';
});